import { Component, input } from '@angular/core';

@Component({
  selector: 'app-pharmacy-dot',
  templateUrl: './pharmacy-dot.component.html',
  styleUrl: './pharmacy-dot.component.scss',
  host: {
    '[class.busy]': "status() === 'busy'",
    '[class.idle]': "status() === 'idle'",
  },
})
export class PharmacyDotComponent {
  status = input.required<'busy' | 'idle'>();
}
